import { useState } from "react";
import { HomeworkSourcesUIProvider } from "./HomeworkSourcesUIContext";
import { ImportFromExcel } from "./ImportFromExcel";
import { HomeworkSourcesCard } from "./HomeworkSourcesCard";

export function HomeworkSourcesPage({ history }) {
  const [showDialog, setShowDialog] = useState(false);
  const closeDialog = () => setShowDialog(false);

  const sourcesUIEvents = {
    openImportFromExcelDialog: () => {
      setShowDialog(true);
    },
    openNewHomeworkSourcePage: () => {
      history.push("/odev-kaynaklari/ekle");
    },
    openEditHomeworkSourcePage: (id) => {
      history.push(`/odev-kaynaklari/duzenle/${id}`);
    },
  };
  
  return (
    <HomeworkSourcesUIProvider sourcesUIEvents={sourcesUIEvents}>
      <ImportFromExcel
        showDialog={showDialog}
        closeDialog={closeDialog}
      />
      <HomeworkSourcesCard />
    </HomeworkSourcesUIProvider>
 );
}